import React from 'react'
import {useParams} from "react-router-dom";
import useBookRecommenderDetail from "./useBookRecommenderDetail";
import RouteContainer from "../../../common/styles/RouteContainer";
import BookRecommenderListRow from "./BookRecommenderListRow";
import RouteTitle from "../../../common/RouteTitle/RouteTitle";
import BooksitoutIcon from "../../../config/BooksitoutIcon";
import RowSpacer from "../../../common/styles/RowSpacer";
import RouteTitleConfig from "../../../config/RouteTitleConfig";
import {Card} from "react-bootstrap";
import CardBodyContentContainer from "../../../common/styles/CardBodyContentContainer";
import CardTitle from "../../../common/styles/CardTitle";
import Spacer from "../../../common/Spacer";
import BookIsbnListRow from "../../book/BookIsbnListRow";
import NoContent from "../../../common/NoContent";
import BookRecommenderListRowLoading from "./BookRecommenderListRowLoading";
import useHtmlTitle from "../../../common/useHtmlTitle";
import BooksitoutImages from "../../../images/BooksitoutImages";

const BookRecommendersDetailRoute = () => {
    const {recommenderId} = useParams()

    const [data, isLoading, isError] = useBookRecommenderDetail(recommenderId)

    useHtmlTitle(`${data?.recommender?.koreanName ?? recommenderId} 책 추천`)

    if (isLoading) {
        return (
            <RouteContainer>
                <RouteTitle
                    icon={<BooksitoutIcon.recommend/>}
                    title={'책 추천 받기'}
                    subTitle={'다양한 분야의 지식인들이 추천한 책을 만나보세요'}
                    currentKey={'recommendations'}
                    buttons={RouteTitleConfig.Community}
                    rightUi={undefined}
                />
                <RowSpacer/>

                <BookRecommenderListRowLoading colorType={'card'}/>
                <RowSpacer size={200}/>
            </RouteContainer>
        )
    }

    if (isError || !data) {
        return <></>
    }

    return (
        <RouteContainer>
            <RouteTitle
                icon={<BooksitoutIcon.recommend/>}
                title={'책 추천 받기'}
                subTitle={'다양한 분야의 지식인들이 추천한 책을 만나보세요'}
                currentKey={'recommendations'}
                buttons={RouteTitleConfig.Community}
                rightUi={undefined}
            />
            <RowSpacer/>

            <Card>
                <CardBodyContentContainer height={data.recommendersBooks.length > 0 ? 300 : 100}>
                    {
                        data.recommender.url ?
                            <BookRecommenderListRow recommender={data.recommender} colorType={"card-card"}
                                                    href={data.recommender.url}/>
                            :
                            <span className={'not-clickable'}>
                                <BookRecommenderListRow recommender={data.recommender} colorType={"card-card"}/>
                            </span>
                    }

                    {data.recommendersBooks.length > 0 &&
                        <div style={{
                            marginTop: '15px',
                            display: 'flex',
                            overflowX: 'auto',
                            scrollbarWidth: 'none',
                            gap: '12px',
                        }}>
                            {data.recommendersBooks.map((book, index) => (
                                <a key={index} href={`/book/${book.isbn13}?q=${book.title}`}
                                   style={{textDecoration: 'none', color: 'inherit', flexShrink: 0, width: '120px', textAlign: 'center'}}>
                                    <div style={{
                                        padding: '10px 10px 0 10px',
                                        borderRadius: '5px',
                                        backgroundColor: 'var(--card-card-bg-color)',
                                        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                                    }}>
                                        <img
                                            src={book.coverUrl ?? BooksitoutImages.Placeholder.bookCover}
                                            alt={book.title}
                                            className={'img-fluid rounded'}
                                            style={{height: '90px', objectFit: 'contain'}}
                                        />
                                        <h5 className={'clamp-2-line'} style={{fontSize: '1.0rem', marginTop: '10px', marginBottom: 0}}>
                                            {book.title}
                                        </h5>
                                    </div>
                                </a>
                            ))}
                        </div>
                    }
                </CardBodyContentContainer>
            </Card>
            <RowSpacer size={10}/>

            {data.recommendations.map((recommendation, index) => (
                <React.Fragment key={index}>
                    <Card>
                        <CardBodyContentContainer height={450}>
                            <CardTitle icon={<></>}
                                       title={recommendation.name ?? (recommendation.date && `${recommendation.date[0].toString().substring(2, 4)}년 ${recommendation.date[1]}월 ${recommendation.date[2]}일 추천 책`)}
                                       url={''}/>

                            {recommendation.source &&
                                <>
                                    <div className="d-flex align-items-center gap-2 mb-3">
                                        <Spacer/>
                                        {recommendation.source.imageUrl && (
                                            <img
                                                src={recommendation.source.imageUrl}
                                                alt="source"
                                                style={{width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px'}}
                                            />
                                        )}

                                        <a href={recommendation.source.url} target="_blank" rel="noopener noreferrer"
                                           className={'text'}>
                                            출처
                                        </a>
                                    </div>
                                </>
                            }

                            {
                                recommendation.books.map((book, bookIndex) => (
                                    <React.Fragment key={bookIndex}>
                                        <BookIsbnListRow book={book}/>
                                    </React.Fragment>
                                ))
                            }
                        </CardBodyContentContainer>
                    </Card>
                    <RowSpacer/>
                </React.Fragment>
            ))}

            {data.recommendations.length == 0 &&
                <>
                    <RowSpacer size={100}/>
                    <NoContent message={'아직 추가된 책 추천이 없어요'}/>
                    <RowSpacer size={100}/>
                </>
            }
        </RouteContainer>
    )
}

export default BookRecommendersDetailRoute
